import React from 'react'
import { Stack } from '@mantine/core'
import SampleReportLink from './SampleReportLink'
import ServiceCommitment from './ServiceCommitment'
import FAQSection from './FAQSection'
import { ThemeConfig } from '../../utils/themeConfig'

interface ReportSidebarProps {
  onSampleReportClick: () => void
  themeConfig: ThemeConfig
}

export default function ReportSidebar({ onSampleReportClick, themeConfig }: ReportSidebarProps) {
  return (
    <div className="lg:sticky lg:top-6">
      <Stack gap="lg">
        <SampleReportLink onClick={onSampleReportClick} themeConfig={themeConfig} />
        <ServiceCommitment themeConfig={themeConfig} />
        <FAQSection themeConfig={themeConfig} />
      </Stack>
    </div>
  )
}
